import React, {useCallback} from 'react';
import {SysPath} from 'SysContext';
import {RAjax} from '@putil-view/request.r-ajax';
import {RSpinner} from '@putil-view/item.components';
import PropTypes from 'prop-types';
export const RequestLockerByUuid = ({setState, uuid})=>{

	const handleGetLockerByUUIDResult = useCallback((result) =>{
		if(result && result.status && result.text){
			setState(prevState =>{
					let newStage = "CAPTURE_IMAGES_AND_VIDEO";
					if(result.status === 'Not Found'){
						newStage = "SCAN_LOCKER_QR_CODE";
						result['text'] = "Invalid QR Code. Please scan the QR code of locker";
					}
					else if(result.type && result.type !== 'locker'){
						newStage = "SCAN_LOCKER_QR_CODE";
						result['text'] = "Invalid QR Code Type. Please scan the QR code of locker";
					}
					return{...prevState , ...{stage:newStage, scanText:result['text']}}
				}
			);
		}
	},[setState])

	const getLockerUrl = SysPath.getLockerUrl + "?uuid="+uuid.current + "&record=false";
	return(
		<>
			<RAjax requestOptions={{
						method: 'get',
						withCredentials: true,
						url: getLockerUrl
					}}
				handleResponse={handleGetLockerByUUIDResult}
			/>
			<h5 className="text-center">Validating QR Code</h5>
			<span className="text-center" style={{width:'700px', height:'700px',display: 'contents'}}> <RSpinner/></span>
		</>
	)
}

RequestLockerByUuid.propTypes = {
	setState: PropTypes.func,
	uuid: PropTypes.oneOfType([
		PropTypes.func, 
		PropTypes.shape({ current: PropTypes.string })
	])
};

